import React from "react";
import { Checkbox } from "@graffer-inc/console-design-kit";

type DisabledBy = "RESTRICTED_FORM_ACCESS";

type Props = {
  value: boolean;
  disabledBy?: DisabledBy;
  onChange: () => void;
};

export const ProcedureSearchEngineSetting: React.FC<Props> = ({
  value,
  disabledBy,
  onChange,
}) => {
  return (
    <div className="field">
      <Checkbox
        id={"procedureSearchEngineSetting"}
        label={"検索エンジンでの表示設定"}
        description={`申請ページを、Googleなどの検索結果に表示しないようにできます。\n${
          typeof disabledBy === "string"
            ? `※ ${messageMapForDisabled[disabledBy]}`
            : ""
        }`}
        options={[
          {
            value: "notDisplayed",
            name: "検索エンジンの結果ページに表示しないようにする",
          },
        ]}
        values={value ? ["notDisplayed"] : []}
        onChange={onChange}
        disabled={typeof disabledBy === "string"}
      />
    </div>
  );
};

const messageMapForDisabled: Record<DisabledBy, string> = {
  RESTRICTED_FORM_ACCESS:
    "フォームにパスコードが要求されている場合、必ず「インデックスしない」設定となります。",
};
